/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;



//////////////////
// WEBPACK FOOTER
// ./~/victory-brush-container/~/lodash/_baseProperty.js
// module id = ./node_modules/victory-brush-container/node_modules/lodash/_baseProperty.js
// module chunks = 1